import React, { useEffect, useState } from 'react';
import ProductCard from '../component/product_card';
import '../productgirdview/product_grid.scss';
import { audienceProductData, fetchtabData } from '../../../sellers_module/services/seller/api';
import PropTypes from 'prop-types';
import { signal_full, signal_half } from '../../../assets';
import { Stack } from '@mui/material';
type Product = {
  _id: string;
  type: string;
  is_purchased: number;
  name: string;
  category: string[];
  price: number;
  discount_price: number;
  audience_size: string;
  image_url: string;
};

type ProductGridViewProps = {
  audienceId: string | null;
  addToCart: (product: Product) => void;
  cart: Product[];
  activeTab: string;
  handleTabClick: (tab: string) => void;
};

const ProductGridView: React.FC<ProductGridViewProps> = ({
  audienceId,
  addToCart,
  cart,
  activeTab,
  handleTabClick,
}) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [tabs, setTabs] = useState<string[]>([]);


  useEffect(() => {
    const fetchTabs = async () => {
      try {
        const tabResponse = await fetchtabData();
        setTabs(tabResponse.data || []);
      } catch {
        setError('Failed to load tabs.');
      }
    };

    fetchTabs();
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      if (!audienceId) return;

      setLoading(true);
      try {
        const data = {
          type: activeTab,
          ad_account_id: audienceId,
        };
        const response = await audienceProductData(data);
        setProducts(response.data.audience || []);
        const isAlreadyPurchased = response.data.audience.filter((items) => items.is_purchased == 1).length > 0 
        sessionStorage.setItem("isAlreadyPurchased", isAlreadyPurchased.toString())
      } catch {
        setError('Failed to fetch products.');
      } finally {
        setLoading(false);

      }
    };

    fetchProducts();
   
  }, [activeTab, audienceId]);



  const Tooltip = ({ text, children }) => (
    <div className="tooltip-wrapper">
      {children}
      {/* <span className="tooltip-text">{text}</span> */}
    </div>
  );

  Tooltip.propTypes = {
    text: PropTypes.string.isRequired, // Validate the text prop as a required string
    children: PropTypes.node.isRequired, // Validate children as required React nodes
  };


  return (

    <div className="product-list">
      
      <div className="tabs">
        {tabs.map((tab, index) => (
          <Tooltip key={tab} text={`${tab}`}>
            <span
              className={`tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => handleTabClick(tab)}
            >
              
             {index == 2 && <img src={signal_half} style={{height:"15px", display :"inline-block", marginRight:"10px"}}/>} 
             {index == 1 && <img src={signal_full} style={{height:"15px", display :"inline-block", marginRight:"10px"}} />}{tab}

            </span>
          </Tooltip>
        ))}
      </div>

      <div className="product-grid">
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>{error}</p>
        ) : products.length > 0 ? (
          products.map((product) => (
            <ProductCard
              key={product._id}
              product={product}
              isInCart={cart.some((item) => item._id === product._id)}
              addToCart={addToCart}
              activeTab={activeTab} 
            />
          ))
        ) : (
          <p>No products available.</p>
        )}
      </div>
    </div>

  );
};

export default ProductGridView;
